<template>
	<view class="app-container" :style="themeStore.cssVars">
		<slot />
	</view>
</template>

<script setup lang="uts">
	import { onLaunch, onShow, onHide, onError } from '@dcloudio/uni-app'
	import { useThemeStore } from '@/sheep/store/theme'
	// import user from '@/sheep/store/user'
	// import { useMessageStore } from '@/sheep/store/message'
	import { initWebSocket, closeWebSocket } from '@/sheep/helper/websocket'
	import { WishesInit } from './sheep';
	import sheep from '@/sheep';

	const themeStore = useThemeStore()
	// const userStore = user()
	// const messageStore = useMessageStore()

	// 应用启动
	onLaunch(async () => {
		console.log('App Launch')

		// 初始化主题
		themeStore.initTheme()

		// 初始化用户登录状态
		// await userStore.init()








		// 获取系统配置（含全局置灰模式）
		loadSystemConfig()

		// 等待应用初始化完成（含租户适配）后再进入首页，避免首页请求时 tenant-id 等上下文未就绪
		await WishesInit();
	})

	// 应用显示
	onShow(() => {
		console.log('App Show')
		// 登录后建立 WebSocket，退出后关闭
		if (sheep.$store('user').isLogin) {
			initWebSocket()
		} else {
			closeWebSocket()
		}
		// 刷新未读消息数
		// messageStore.fetchUnreadCount()
	})

	// 应用隐藏
	onHide(() => {
		console.log('App Hide')
	})

	// 应用错误
	onError((err) => {
		console.error('App Error:', err)
	})

	// 加载系统配置
	const loadSystemConfig = async () => {
		try {
			// 从本地缓存获取
			const grayMode = uni.getStorageSync('grayMode')
			if (grayMode) {
				themeStore.setGrayMode(grayMode)
			}

			// 从服务器获取最新配置
			// const res = await api.config.getSystem()
			// if (res.isGrayMode !== undefined) {
			//   themeStore.setGrayMode(res.isGrayMode)
			//   uni.setStorageSync('grayMode', res.isGrayMode)
			// }
		} catch (e) {
			console.error('加载系统配置失败:', e)
		}
	}

	// App 热更新检查
	const checkAppUpgrade = () => {






























	}

	// 下载并安装更新
	const downloadAndInstall = (url : string) => {






































	}
</script>

<style lang="scss">
	/* 全局样式 */
	page {
		font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-size: $font-size-body;
		color: $text-primary;
		background-color: $bg-primary;
		line-height: 1.5;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	/* 全局置灰模式 */
	.gray-mode {
		filter: grayscale(100%);
		-webkit-filter: grayscale(100%);
	}

	/* 重置样式 */
	page,
	view,
	text,
	image,
	input,
	button,
	textarea,
	scroll-view,
	swiper,
	swiper-item,
	navigator,
	cover-view,
	cover-image {
		box-sizing: border-box;
	}

	/* 图片默认样式 */
	image {
		display: block;
		max-width: 100%;
	}

	/* 按钮重置 */
	button {
		margin: 0;
		padding: 0;
		background: none;
		border: none;
		font-size: inherit;
		line-height: inherit;

		&::after {
			border: none;
		}
	}

	/* 滚动条隐藏 */
	::-webkit-scrollbar {
		display: none;
		width: 0 !important;
		height: 0 !important;
		-webkit-appearance: none;
		background: transparent;
	}

	/* 动画效果 */
	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@keyframes slideUp {
		from {
			transform: translateY(20px);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	@keyframes scaleIn {
		from {
			transform: scale(0.9);
			opacity: 0;
		}

		to {
			transform: scale(1);
			opacity: 1;
		}
	}

	@keyframes pulse {

		0%,
		100% {
			transform: scale(1);
		}

		50% {
			transform: scale(1.05);
		}
	}

	.animate-fade-in {
		animation: fadeIn 0.3s ease-out;
	}

	.animate-slide-up {
		animation: slideUp 0.3s ease-out;
	}

	.animate-scale-in {
		animation: scaleIn 0.2s ease-out;
	}

	.animate-pulse {
		animation: pulse 1s ease-in-out infinite;
	}
</style>